export default __webpack_public_path__ + "static/home-card-women-back-to-work-b273ccba51e50647d575693db462294a.svg";